// extracted by mini-css-extract-plugin
export default {"baner":"style_baner__zLZb5","baner_content":"style_baner_content__UAAcw","description":"style_description__ISGlu","main_container":"style_main_container__e5udJ"};